// App.js

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Dashboard from './pages/Dashboard'
import PublicSession from './pages/sessions/PublicSession'
import SessionList from './pages/sessions/SessionList'
import SessionDetail from './pages/sessions/SessionDetail'
import LanguageAdmin from './pages/languages/LanguageAdmin'
import UserProfile from './pages/user/UserProfile'
import QuestionnaireCreate from './pages/questionnaire/QuestionnaireCreate'
import QuestionnaireList from './pages/questionnaire/QuestionnaireList'
import QuestionnaireEdit from './pages/questionnaire/QuestionnaireEdit'

import JobCreate from './pages/jobs/JobCreate'
import SitesCreate from './pages/sites/SitesCreate'
import SiteList from './pages/sites/SiteList'
import LocationCreate from './pages/locations/LocationCreate'
import LocationPage from './pages/locations/LocationPage'
import CompanyTruckersList from './pages/trucker/CompanyTruckersList'
import ManageJobsList from './pages/jobs/ManageJobsList'
import ManageJobEdit from './pages/jobs/ManageJobEdit'
import CompanyJobMessagesList from './pages/messages/CompanyJobMessagesList'
import CompanyConversationsList from './pages/messages/CompanyConversationsList'
import QRCodeButton from './pages/qrcode/QRCodeButton'
import BarcodeEdit from './pages/qrcode/BarcodeEdit'
import RegistrationOverview from "./pages/registration/RegistrationOverview"

import Register from './pages/auth/Register'
import Confirm from './pages/auth/Confirm'
import Login from './pages/auth/Login'
import PublicRoute from './context/PublicRoute'
import PrivateRoute from './context/PrivateRoute'
import Footer from './components/Footer'
import './assets/css/App.css'

function App() {
  console.log("[APP] Rendering App component")
  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content">
        <Routes>
          <Route path="register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="confirm" element={<PublicRoute><Confirm /></PublicRoute>} />
          <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="session-list" element={<PrivateRoute><SessionList /></PrivateRoute>} />
          <Route path="session/:sessionId" element={<PrivateRoute><SessionDetail /></PrivateRoute>} />
          <Route path="public-session" element={<PublicSession />} />
          <Route path="language-admin" element={<PrivateRoute><LanguageAdmin /></PrivateRoute>} />
          <Route path="profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
          <Route path="questionnaire-create" element={<PrivateRoute><QuestionnaireCreate /></PrivateRoute>} />
          <Route path="questionnaire-list" element={<PrivateRoute><QuestionnaireList /></PrivateRoute>} />
          <Route path="questionnaire-edit/:id" element={<PrivateRoute><QuestionnaireEdit /></PrivateRoute>} />

	  	  <Route path="create-job" element={<PrivateRoute><JobCreate /></PrivateRoute>} />
          <Route path="create-site" element={<PrivateRoute><SitesCreate /></PrivateRoute>} />
          <Route path="our-sites" element={<PrivateRoute><SiteList /></PrivateRoute>} />
          <Route path="company-conversations" element={<PrivateRoute><CompanyConversationsList /></PrivateRoute>} />
          <Route path="job-messages/:jobId" element={<PrivateRoute><CompanyJobMessagesList /></PrivateRoute>} />
          <Route path="create-location" element={<PrivateRoute><LocationCreate /></PrivateRoute>} />
          <Route path="our-locations" element={<PrivateRoute><LocationPage /></PrivateRoute>} />
          <Route path="truckers" element={<PrivateRoute><CompanyTruckersList /></PrivateRoute>} />
          <Route path="manage-jobs" element={<PrivateRoute><ManageJobsList /></PrivateRoute>} />
          <Route path="manage-jobs/edit/:jobId" element={<PrivateRoute><ManageJobEdit /></PrivateRoute>} />
          <Route path="qrcode" element={<PrivateRoute><QRCodeButton /></PrivateRoute>} />
          <Route path="barcode-edit/:id" element={<PrivateRoute><BarcodeEdit /></PrivateRoute>} />
	  	  <Route path="registration-overview" element={<PrivateRoute><RegistrationOverview /></PrivateRoute>} />
        </Routes>
      </div>
      <Footer />
    </div>
  )
}

export default App
